/**
 * Mobile layout of the Unique Impact section: the two paragraphs, then the icon centred in an 83 px
 * square. It draws no title; the page's `AllSections` accordion tab shows it.
 *
 * It is a copy of `../../EnvironmentHealthSafety/JobSafety/JobSafetyMobile.tsx` (the component
 * keeps the name `JobSafetyMobile`) with three differences: the icon is always drawn, it sits in
 * an 83 px square box (`ImageContainer`) where `JobSafetyMobile` draws it at its natural size,
 * and nothing follows it. `JobSafetyMobile` appends the Environment, Health & Safety
 * Communication & Safety block unless `noSecondarySection` is set, and `UniqueImpactProps` has
 * no such field.
 */
import styled from "@emotion/styled";
import React from "react";
import { ContentSection, Flex, FlexItem } from "@ryerson/frontend.layout";
import { UniqueImpactProps } from "./UniqueImpact";
import { Typography } from "@ryerson/frontend.typography";

const Paragraph = styled(Flex)`
	margin-top: 4px;
	margin-bottom: 20px;
`;

const ImageContainer = styled(FlexItem)`
	width: 83px;
	height: 83px;

	img {
		max-width: 100%;
	}
`;

/** Renders the Unique Impact section below `lg`. */
const JobSafetyMobile: React.FC<UniqueImpactProps> = ({ ...props }) => {
	return (
		<ContentSection hPadding="0px">
			<Flex direction="column">
				<Paragraph>
					<Typography size="md">{props?.paragraph1}</Typography>
				</Paragraph>
				<Paragraph>
					<Typography size="md">{props?.paragraph2}</Typography>
				</Paragraph>
				<Flex justifyContent="center" alignItems="center">
					<ImageContainer>
						<img src={props?.imageUrl} alt={props.title} />
					</ImageContainer>
				</Flex>
			</Flex>
		</ContentSection>
	);
};

export default JobSafetyMobile;
